import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AlertInput} from '@ionic/core';
import * as apiVeranstaltungen from '../../../../clients/veranstaltungen';
import {PostMitteilungSenden2Action} from '../../../../client-ngrx/veranstaltungen';
import {Funktionsbereich, VeranstaltungMitteilungBerechtigung, VeranstaltungMitteilungsVorlage} from '../../../../clients/veranstaltungen';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import * as apiKommunikation from '../../../../clients/kommunikation';
import {PostMitteilungLoeschenAction} from '../../../../client-ngrx/kommunikation';
import {ListInputItem} from '../../../shared/sopi-list/sopi-list.model';
import * as fromMitteilungenPage from './mitteilungen.reducer';
import * as fromSelector from './mitteilungen.selectors';
import {getMitteilungsVorlagen, getMitteilungsVorlagenFehler, getMitteilungsVorlagenLaden, getVeranstaltungMitteilungBerechtigung, getVeranstaltungMitteilungBerechtigungFehler, getVeranstaltungMitteilungBerechtigungLaden} from './mitteilungen.selectors';
import {AlertController, IonTextarea} from '@ionic/angular';
import {getAktuelleVeranstaltung, getVeranstaltungDeckblatt} from '../../app-state/app-state.reducer';
import {PageStateResetAction} from './mitteilungen.actions.ui';
import {FunktionsbereichUi, RolleUi} from './mitteilungen.model';

@Component({
    selector: 'app-mitteilungen',
    templateUrl: './mitteilungen.page.html'
})

export class MitteilungenPage implements OnInit {
    @ViewChild('mitteilungstextInput', {static: false}) mitteilungstextInput: IonTextarea;

    nachrichtenTyp = 'empfangen';

    public aktuelleVeranstaltung$: Observable<apiVeranstaltungen.Veranstaltung>;
    aktuelleVeranstaltung: apiVeranstaltungen.Veranstaltung;

    public aktuelleVeranstaltungDeckblatt$: Observable<apiVeranstaltungen.VeranstaltungDetail>;
    aktuelleVeranstaltungDeckblatt: apiVeranstaltungen.VeranstaltungDetail;

    public aktuelleMitteilung: apiVeranstaltungen.Mitteilung;
    istMitteilungAnAlle = false;
    istMitteilungAnAlleFbFreigeber = false;
    istMitteilungAnFbFreigeber = false;
    istMitteilungAnMitgliederFb = false;
    istMitteilungAnMitgliederRolle = false;
    ausgewaehlteFunktionsbereiche: Array<string> = [];
    ausgewaehlteFreigeberFunktionsbereiche: Array<string> = [];
    ausgewaehlteRollen: Array<string> = [];

    veranstaltungBerechtigung: apiVeranstaltungen.VeranstaltungBerechtigung;
    veranstaltungBerechtigung$: Observable<apiVeranstaltungen.VeranstaltungBerechtigung>;

    veranstaltungMitteilungBerechtigung: VeranstaltungMitteilungBerechtigung;
    veranstaltungMitteilungBerechtigung$: Observable<VeranstaltungMitteilungBerechtigung>;
    veranstaltungMitteilungBerechtigungLaden$: Observable<boolean>;
    veranstaltungMitteilungBerechtigungFehler$: Observable<boolean>;

    uiZeigeMitteilungenLaden$: Observable<boolean>;
    uiZeigeMitteilungenLadefehler$: Observable<boolean>;
    mitteilungen$: Observable<Array<ListInputItem>>;

    funktionsbereiche$: Observable<Array<Funktionsbereich>>;
    mitteilungenGesendet$: Observable<Array<ListInputItem>>;
    uiZeigeMitteilungenGesendetLaden$: Observable<boolean>;
    uiZeigeMitteilungenGesendetLadefehler$: Observable<boolean>;
    aktuelleFunktionsbereiche: Array<FunktionsbereichUi> = [];
    aktuelleFreigeberFunktionsbereiche: Array<FunktionsbereichUi> = [];
    aktuelleRollen: Array<RolleUi> = [];

    public mitteilungsVorlagen$: Observable<Array<VeranstaltungMitteilungsVorlage>>;
    public mitteilungsVorlagenLaden$: Observable<boolean>;
    public mitteilungsVorlagenFehler$: Observable<boolean>;


    mitteilungstext = '';

    private vorlageTemplate = false;

    constructor(private store: Store<fromMitteilungenPage.PageState>,
                public alertCtrl: AlertController,
                public element: ElementRef) {


    }

    ngOnInit() {
        this.store.dispatch(new PageStateResetAction());

        this.aktuelleVeranstaltung$ = this.store.pipe(select(getAktuelleVeranstaltung));
        this.aktuelleVeranstaltung$.subscribe(x => {
            this.aktuelleVeranstaltung = x;
        });

        this.aktuelleVeranstaltungDeckblatt$ = this.store.pipe(select(getVeranstaltungDeckblatt));
        this.aktuelleVeranstaltungDeckblatt$.subscribe(x => {
            this.aktuelleVeranstaltungDeckblatt = x;
        });

        this.veranstaltungMitteilungBerechtigung$ = this.store.pipe(select(getVeranstaltungMitteilungBerechtigung));
        this.veranstaltungMitteilungBerechtigung$.subscribe(x => {
            this.veranstaltungMitteilungBerechtigung = x;
        });
        this.veranstaltungMitteilungBerechtigungLaden$ = this.store.pipe(select(getVeranstaltungMitteilungBerechtigungLaden));
        this.veranstaltungMitteilungBerechtigungFehler$ = this.store.pipe(select(getVeranstaltungMitteilungBerechtigungFehler));

        this.veranstaltungBerechtigung$ = this.store.pipe(select(fromSelector.getVeranstaltungBerechtigung));
        this.veranstaltungBerechtigung$.subscribe(x => {
            this.veranstaltungBerechtigung = x;
        });
        this.mitteilungen$ = this.store.pipe(select(fromSelector.getMitteilungenListe));
        this.uiZeigeMitteilungenLaden$ = this.store.pipe(select(fromSelector.getUiZeigeMitteilungenLaden));
        this.uiZeigeMitteilungenLadefehler$ = this.store.pipe(select(fromSelector.getUiZeigeMitteilungenLadefehler));

        this.funktionsbereiche$ = this.store.pipe(select(fromSelector.getUiFunktionsbereicheZurAuswahlListe));

        this.mitteilungenGesendet$ = this.store.pipe(select(fromSelector.getMitteilungenGesendetListe));
        this.uiZeigeMitteilungenGesendetLaden$ = this.store.pipe(select(fromSelector.getUiZeigeMitteilungenGesendetLaden));
        this.uiZeigeMitteilungenGesendetLadefehler$ = this.store.pipe(select(fromSelector.getUiZeigeMitteilungenGesendetLadefehler));

        this.mitteilungsVorlagen$ = this.store.pipe(select(getMitteilungsVorlagen));
        this.mitteilungsVorlagenLaden$ = this.store.pipe(select(getMitteilungsVorlagenLaden));
        this.mitteilungsVorlagenFehler$ = this.store.pipe(select(getMitteilungsVorlagenFehler));

        this.nachrichtenTyp = 'empfangen';
    }

    ionViewWillEnter() {
    }

    // Mitteilungen
    async mitteilungAuswaehlen(item) {
        // console.log('Mitteilung auswählen. ', item);
        if (item !== null && item.mitteilung !== null && item.mitteilung.mitteilung_id !== null) {
            this.aktuelleMitteilung = item.mitteilung;
        }
    }

    async mitteilungLoeschen(mitteilung) {
        if (mitteilung !== null && mitteilung.mitteilung_id !== null) {
            const mitteilungLoeschenRequest = <apiKommunikation.MitteilungLoeschenRequest>{
                mitteilung_id: mitteilung.mitteilung_id,
                zeitpunkt_utc: new Date()
            };
            this.store.dispatch(new PostMitteilungLoeschenAction(mitteilungLoeschenRequest));
        }
    }

    async zeigeFunktionsbereichsAuswahl() {
        if (this.istMitteilungAnMitgliederFb) {
            const funktionsbereiche = this.veranstaltungMitteilungBerechtigung.funktionsbereiche;

            const alert = await this.alertCtrl.create({
                header: 'Auswahl Funktionsbereiche der Mitglieder',
                buttons: [
                    {
                        text: 'Abbrechen',
                        handler: data => {
                        }
                    },
                    {
                        text: 'Fertig',
                        handler: data => {
                            this.ausgewaehlteFunktionsbereiche = data;
                            // this.aktuelleFunktionsbereiche = this.aktuelleFunktionsbereiche.map(item => {
                            this.aktuelleFunktionsbereiche = this.aktuelleFunktionsbereiche.map(item => {
                                const aktive = (this.ausgewaehlteFunktionsbereiche.findIndex(x => x === item.funktionsbereich_id) !== -1);
                                return Object.assign({}, item, {aktive});
                            });
                        }
                    }
                ]
            });

            const inputs: Array<AlertInput> = [];
            if (funktionsbereiche != null) {
                this.aktuelleFunktionsbereiche = [];
                // Wenn es kein Veranstaltungsleiter ist, muss die Liste der Funktionsbereiche gefiltert werden
                funktionsbereiche.filter(fb => this.veranstaltungBerechtigung.benutzer_ist_veranstaltungsleiter || this.veranstaltungMitteilungBerechtigung.senden_an_benutzer_funktionsbereich_ids.findIndex(benutzerFB => benutzerFB === fb.funktionsbereich_id) !== -1).forEach(
                    (item) => {
                        const aktive = (this.ausgewaehlteFunktionsbereiche.findIndex(x => x === item.funktionsbereich_id) !== -1);
                        inputs.push(<AlertInput>{
                            type: 'checkbox',
                            label: item.titel,
                            value: item.funktionsbereich_id,
                            checked: aktive
                        });
                        this.aktuelleFunktionsbereiche.push(<FunktionsbereichUi>Object.assign({}, item, {aktive}));
                    }
                );
            }
            alert.inputs = inputs;
            await alert.present();
        } else {
            this.ausgewaehlteFunktionsbereiche = [];
        }
    }

    async zeigeFreigeberFunktionsbereichsAuswahl() {

        // TODO: Wenn Veranstaltungsleiter, dann muss hier die komplette Liste der Funktionsbereich mitgegeben werden

        if (this.istMitteilungAnFbFreigeber) {
            const funktionsbereiche = this.veranstaltungMitteilungBerechtigung.funktionsbereiche;

            const alert = await this.alertCtrl.create({
                header: 'Auswahl Funktionsbereiche der Freigeber',
                buttons: [
                    {
                        text: 'Abbrechen',
                        handler: data => {
                        }
                    },
                    {
                        text: 'Fertig',
                        handler: data => {
                            this.ausgewaehlteFreigeberFunktionsbereiche = data;
                            this.aktuelleFreigeberFunktionsbereiche = this.aktuelleFreigeberFunktionsbereiche.map(item => {
                                const aktive = (this.ausgewaehlteFreigeberFunktionsbereiche.findIndex(x => x === item.funktionsbereich_id) !== -1);
                                return Object.assign({}, item, {aktive});
                            });
                        }
                    }
                ]
            });

            const inputs: Array<AlertInput> = [];
            if (funktionsbereiche != null) {
                this.aktuelleFreigeberFunktionsbereiche = [];
                funktionsbereiche.forEach(
                    (item) => {
                        const aktive = (this.ausgewaehlteFreigeberFunktionsbereiche.findIndex(x => x === item.funktionsbereich_id) !== -1);
                        inputs.push(<AlertInput>{
                            type: 'checkbox',
                            label: item.titel,
                            value: item.funktionsbereich_id,
                            checked: aktive
                        });
                        this.aktuelleFreigeberFunktionsbereiche.push(<FunktionsbereichUi>Object.assign({}, item, {aktive}));
                    }
                );
            }
            alert.inputs = inputs;
            await alert.present();

        } else {
            this.ausgewaehlteFreigeberFunktionsbereiche = [];
        }
    }

    async zeigeRollenAuswahl(event) {
        if (this.istMitteilungAnMitgliederRolle && !this.vorlageTemplate) {
            const rollen = this.veranstaltungMitteilungBerechtigung.rollen;

            const alert = await this.alertCtrl.create({
                header: 'Auswahl Rollen der Mitglieder',
                buttons: [
                    {
                        text: 'Abbrechen',
                        handler: data => {
                        }
                    },
                    {
                        text: 'Fertig',
                        handler: data => {
                            this.ausgewaehlteRollen = data;
                            this.aktuelleRollen = this.aktuelleRollen.map(item => {
                                const aktive = (this.ausgewaehlteRollen.findIndex(x => x === item.rolle.rolle_id) !== -1);
                                return Object.assign({}, item, {aktive});
                            });
                        }
                    }
                ]
            });

            const inputs: Array<AlertInput> = [];
            if (rollen != null) {
                this.aktuelleRollen = [];
                // Wenn es kein Veranstaltungsleiter ist, muss die Liste der Funktionsbereiche gefiltert werden
                rollen.forEach(
                    (item) => {
                        const aktive = (this.ausgewaehlteRollen.findIndex(x => x === item.rolle.rolle_id) !== -1);
                        inputs.push(<AlertInput>{
                            type: 'checkbox',
                            label: item.rolle.titel,
                            value: item.rolle.rolle_id,
                            checked: aktive
                        });
                        this.aktuelleRollen.push(<RolleUi>Object.assign({}, item, {aktive}));
                    }
                );
            }
            alert.inputs = inputs;
            await alert.present();
        } else {
            if (!event.detail.checked) {
                this.ausgewaehlteRollen = [];
                this.aktuelleRollen = [];
            }
        }
    }

    async mitteilungSenden() {
        if (this.mitteilungstext != null && this.mitteilungstext !== '' &&
            (this.istMitteilungAnAlle || this.istMitteilungAnAlleFbFreigeber ||
                (this.istMitteilungAnMitgliederFb && this.ausgewaehlteFunktionsbereiche.length > 0) ||
                (this.istMitteilungAnFbFreigeber && this.ausgewaehlteFreigeberFunktionsbereiche.length > 0) ||
                (this.istMitteilungAnMitgliederRolle && this.ausgewaehlteRollen.length > 0))) {
            const request = <apiVeranstaltungen.MitteilungenSendenRequest2>{
                fb_benutzer_funktionsbereich_ids: this.ausgewaehlteFunktionsbereiche,
                fb_freigeber_funktionsbereich_ids: this.ausgewaehlteFreigeberFunktionsbereiche,
                rolle_benutzer_rollen_ids: this.ausgewaehlteRollen.map(x => x),
                veranstaltung_id: this.aktuelleVeranstaltung.veranstaltung_id,
                zeitpunkt_utc: new Date(),
                text: this.mitteilungstext,
                senden_an_dienstplan: this.istMitteilungAnAlle,
                senden_an_fb_benutzer: this.istMitteilungAnMitgliederFb,
                senden_an_fb_freigeber: this.istMitteilungAnFbFreigeber,
                senden_an_alle_fb_freigeber: this.istMitteilungAnAlleFbFreigeber,
                senden_an_rolle_benutzer: this.istMitteilungAnMitgliederRolle
            };
            this.store.dispatch(new PostMitteilungSenden2Action(request));

            this.mitteilungstext = '';
            this.istMitteilungAnAlle = false;
            this.istMitteilungAnAlleFbFreigeber = false;
            this.istMitteilungAnMitgliederFb = false;
            this.istMitteilungAnFbFreigeber = false;
            this.istMitteilungAnMitgliederRolle = false;
            this.ausgewaehlteFunktionsbereiche = [];
            this.ausgewaehlteFreigeberFunktionsbereiche = [];
            this.ausgewaehlteRollen = [];
            this.aktuelleRollen = [];

        } else {
            let message = '';
            if ((!this.istMitteilungAnAlle && !this.istMitteilungAnAlleFbFreigeber &&
                !(this.istMitteilungAnMitgliederFb && this.ausgewaehlteFunktionsbereiche.length > 0) &&
                !(this.istMitteilungAnFbFreigeber && this.ausgewaehlteFreigeberFunktionsbereiche.length > 0) &&
                !(this.istMitteilungAnMitgliederRolle && this.aktuelleRollen.length > 0))) {
                message = 'Bitte mindestens eine Empfängergruppe auswählen.';
            } else if (this.mitteilungstext == null || this.mitteilungstext === '') {
                message = 'Bitte eine Nachricht angeben.';
            }

            const alert = await this.alertCtrl.create({
                header: 'Fehlende Angaben',
                message,
                buttons: [
                    {
                        text: 'OK',
                        handler: data => {
                        }
                    }
                ]
            });

            await alert.present();
        }
    }

    parseStringWithVeranstaltung(veranstaltung: apiVeranstaltungen.Veranstaltung, parseString: string) {
        if (parseString === null) {
            return '';
        }
        parseString = parseString.replace('{{TITEL}}', veranstaltung.titel);
        parseString = parseString.replace('{{SAISON}}', veranstaltung.saison_id);
        parseString = parseString.replace('{{TYP_BEZEICHNUNG}}', veranstaltung.typ_bezeichnung);
        parseString = parseString.replace('{{EINLASS:d}}', new Date(veranstaltung.einlass_utc).toLocaleDateString());
        parseString = parseString.replace('{{BEGINN:d}}', new Date(veranstaltung.beginn_utc).toLocaleDateString());
        parseString = parseString.replace('{{EINLASS:t}}', new Date(veranstaltung.einlass_utc).toLocaleTimeString().substring(0, 5));
        parseString = parseString.replace('{{BEGINN:t}}', new Date(veranstaltung.beginn_utc).toLocaleTimeString().substring(0, 5));
        this.aktuelleVeranstaltungDeckblatt.kopfdaten.forEach(item => parseString = parseString.replace('{{' + item.key + '}}', item.wert));
        return parseString;
    }

    async nachrichtenTemplateSenden(vorlage: VeranstaltungMitteilungsVorlage) {
        this.vorlageTemplate = true;

        // const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];
        this.aktuelleVeranstaltungDeckblatt$.subscribe(x => {
            // replace
            this.mitteilungstext = this.parseStringWithVeranstaltung(x, vorlage.beschreibung);

            const neueRollen: Array<RolleUi> = [];
            vorlage.empfaenger_rollen.forEach(rolle => neueRollen.push(<RolleUi>Object.assign({}, rolle, {aktive: true})));

            if (neueRollen.length === 0) {
                this.istMitteilungAnAlle = true;
                this.istMitteilungAnAlleFbFreigeber = false;
                this.istMitteilungAnFbFreigeber = false;
                this.istMitteilungAnMitgliederFb = false;
                this.istMitteilungAnMitgliederRolle = false;
            } else {
                this.istMitteilungAnAlle = false;
                this.istMitteilungAnAlleFbFreigeber = false;
                this.istMitteilungAnFbFreigeber = false;
                this.istMitteilungAnMitgliederFb = false;
                this.istMitteilungAnMitgliederRolle = true;
            }

            this.aktuelleRollen = neueRollen;
            this.ausgewaehlteRollen = neueRollen.map(r => r.rolle.rolle_id);

            // set focus an resize
            // textArea.focus();
            setTimeout(() => {
                if (this.mitteilungstextInput) {
                    this.mitteilungstextInput.setFocus();
                }
                this.vorlageTemplate = false;
            }, 500);

            setTimeout(() => {
                this.autoresize();
            }, 300);
        }).unsubscribe();
    }

    async autoresize($event = null) {
        const textArea = this.element.nativeElement.getElementsByTagName('textarea')[0];

        if (this.element.nativeElement.getElementsByTagName('textarea')[0].scrollHeight <= 200) {
            textArea.style.overflow = 'hidden';
            textArea.style.height = 'auto';
            textArea.style.height = this.element.nativeElement.getElementsByTagName('textarea')[0].scrollHeight + 'px';
        } else {
            textArea.style.overflow = 'auto';
            textArea.style.height = 'auto';
            textArea.style.height = '200px';
        }
    }

}
